import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card } from "@/components/ui/card";
import { Calendar, User } from "lucide-react";

interface DashboardHeaderProps {
  userName: string;
  userRole: string;
  userAvatar?: string;
}

export const DashboardHeader = ({ userName, userRole, userAvatar }: DashboardHeaderProps) => {
  const currentDate = new Date().toLocaleDateString('pt-BR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <Card className="p-4 sm:p-6 bg-gradient-card shadow-card cursor-pointer hover:shadow-card-hover transition-shadow">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center space-x-4 min-w-0">
          <Avatar className="h-12 w-12 sm:h-16 sm:w-16 border-2 border-primary/20 shrink-0">
            <AvatarImage src={userAvatar} alt={userName} />
            <AvatarFallback className="bg-primary/10 text-primary font-semibold text-lg">
              <User className="h-8 w-8" />
            </AvatarFallback>
          </Avatar>

          <div className="min-w-0">
            <h1 className="text-xl sm:text-2xl font-bold text-foreground truncate">
              Olá, {userName}!
            </h1>
            <p className="text-muted-foreground font-medium truncate">
              {userRole}
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-2 text-muted-foreground min-w-0">
          <Calendar className="h-5 w-5 shrink-0" />
          <span className="text-sm font-medium capitalize">
            {currentDate}
          </span>
        </div>
      </div>
    </Card>
  );
};